export default __webpack_public_path__ + "static/media/P00124182_WF_BRAND_1HFY24ISF_Art10_1164x584.cdc06026.jpg";